import { Document, Block } from 'slate'

import _getEntitiesRange from './getEntitiesRange'
import _getDefaultValue from './getDefaultValue'

export const getEntitiesRange = _getEntitiesRange
export const getDefaultValue = _getDefaultValue

function serializeNode(node, delimiter = '\n') {
  if (
    Document.isDocument(node) ||
    (Block.isBlock(node) && Block.isBlockList(node.nodes))
  ) {
    return node.nodes.map(serializeNode).join(delimiter)
  }
  return node.text
}

export function convertValueToText(value) {
  return serializeNode(value.document)
}

export function convertValueToEntities(value) {
  return getEntitiesRange(value)
}
